import React, { useState, useContext } from 'react';
import InputField from '../components/InputField';
import { ThemeContext } from '../theme';

const SIGNUP_ILLUS_URL = 'https://res.cloudinary.com/dcnujnpbm/image/upload/q_auto/f_auto/v1776961695/onboarding_image_1_muilsk.webp';

// All sizing values are 0.75× of the Figma baseline (Figma frame ~1440px, our container 872px)
export default function SignupScreen({ onLogin, onNext }) {
  const theme = useContext(ThemeContext);
  const [email,       setEmail]       = useState('');
  const [profileName, setProfileName] = useState('');
  const [password,    setPassword]    = useState('');

  return (
    <div style={{ flex: 1, alignSelf: 'stretch', display: 'flex', backgroundColor: theme.bgPrimary }}>
      <style>{`
        @keyframes onboardImgScaleOut {
          from { transform: scale(1.2); }
          to   { transform: scale(1); }
        }
      `}</style>

      {/* Left panel — illustration */}
      <div style={{ width: '38%', flexShrink: 0, position: 'relative', overflow: 'hidden', backgroundColor: theme.cardBg100 }}>
        <img
          src={SIGNUP_ILLUS_URL}
          alt=""
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', animation: 'onboardImgScaleOut 0.6s ease-out both' }}
        />
      </div>

      {/* Right panel — form. Padding: 32×0.75=24px / 48×0.75=36px */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 104px',
          overflowY: 'auto',
          backgroundColor: theme.cardBg,
        }}
      >
        {/* Section gap: 48×0.75=36px */}
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 36 }}>

          {/* Title: 40×0.75=30px / 52×0.75=39px */}
          <h1
            className="font-bogart"
            style={{ fontSize: 30, fontWeight: 700, lineHeight: '39px', color: theme.text100, margin: 0 }}
          >
            Welcome!
          </h1>

          {/* Fields gap: 16×0.75=12px */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <InputField
              label="E-mail"
              required
              type="email"
              placeholder="eda_yildiz@gmail.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              scale={0.75}
            />
            <InputField
              label="Profile Name"
              required
              type="text"
              placeholder="Eda"
              value={profileName}
              onChange={e => setProfileName(e.target.value)}
              scale={0.75}
            />
            <InputField
              label="Password"
              required
              type="password"
              placeholder="••••••••••••••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              hint="Password Suggestions"
              scale={0.75}
            />
          </div>

          {/* Actions gap: 80×0.75=60px */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 60 }}>
            {/* Button: padding 20×0.75=15px, radius 20×0.75=15px, font 18×0.75=14px */}
            <button
              onClick={onNext}
              className="font-satoshi font-bold"
              style={{
                width: '100%',
                padding: '15px',
                borderRadius: 15,
                border: 'none',
                backgroundColor: theme.btnPrimaryBg,
                color: theme.btnPrimaryText,
                fontSize: 14,
                lineHeight: '18px',
                cursor: 'pointer',
                transition: 'background-color 0.15s',
              }}
            >
              Sign up
            </button>

            {/* Footer: 18×0.75=14px */}
            <p className="font-satoshi" style={{ margin: 0, textAlign: 'center', fontSize: 14, lineHeight: '18px', color: theme.text100 }}>
              Already have an account?{' '}
              <button
                onClick={onLogin}
                className="font-satoshi font-bold"
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 700,
                  fontSize: 14,
                  color: theme.text100,
                  padding: 0,
                }}
              >
                Log in
              </button>
            </p>
          </div>

        </div>
      </div>

    </div>
  );
}
